import gql from "graphql-tag";

export const MY_NEWS_REMOVE_ITEM = gql`
  mutation removeMyNewsItem($_id: String!) {
    removeMyNewsItem(_id: $_id)
  }
`;
